import React, { useState, useEffect } from "react";
import { FiUser, FiMail, FiPhone, FiEdit2, FiSave, FiShield, FiInfo, FiUsers, FiFileText } from "react-icons/fi";
import { getAccountData } from "@/context/getAccountData";


export default function AccountInfoView() {
  const [editing, setEditing] = useState(false);
  const [userData, setUserData] = useState({
    name: "Carlos Mendoza",
    email: "carlos.mendoza@ejemplo.com",
    phone: "+34 612 345 678",
    profession: "Abogado",
    specialty: "Derecho Mercantil",
    address: "Calle Gran Vía 123, Madrid",
    memberSince: "Enero 2023"
  });

  const [formData, setFormData] = useState({ ...userData });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setUserData({ ...formData });
    setEditing(false);
  };

  const handleCancel = () => {
    setFormData({ ...userData });
    setEditing(false);
  };

  const [accountData, setAccountData] = useState(null);
  console.log(accountData)
  const nameParts = accountData?.username?.split(" ") || [];
  const firstName = nameParts[0] || "";
  const firstLastName = nameParts[1] || "";
  useEffect(() => {

    async function fetchData() {
      try {

        const data = await getAccountData();
        setAccountData(data);
      } catch (error) {
        console.error("Error al obtener los datos de la cuenta:", error);
      }
    }
    fetchData();
  }, []);

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="border-b border-gray-200">
        <div className="px-6 py-5">
          <h1 className="text-2xl font-bold text-gray-800 flex items-center">
            <FiUser className="mr-3" /> Información de la Cuenta
          </h1>
          <p className="text-gray-600 mt-1">
            Administra tu información personal y configuración de cuenta
          </p>
        </div>
      </div>

      <div className="p-6">
        <div className="flex flex-col md:flex-row gap-8">
          {/* Left Column - User Photo and Subscription */}
          <div className="md:w-1/3">
            <div className="flex flex-col items-center p-4 border rounded-lg bg-gray-50">
              <div className="w-32 h-32 rounded-full bg-navy-100 flex items-center justify-center text-navy-600 text-4xl font-bold mb-4">
                {accountData?.username.split(' ').map(n => n[0]).join('')}
              </div>

              <h3 className="text-lg font-medium">{firstName} {firstLastName}</h3>
              <p className="text-gray-600 text-sm">{accountData?.user_type}</p>
              {accountData?.user_type !== "Client" && (
                <p className="text-gray-500 text-sm mt-1">{userData?.specialty}</p>
              )}

              <div className="mt-6 w-full">
                <div className="flex justify-between items-center mb-2">
                  <div className="flex items-center">
                    <FiUsers className="mr-2 text-navy-600" />
                    <span className="text-gray-700">Plan Actual</span>
                  </div>
                  <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded">Premium</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-navy-600 h-2 rounded-full" style={{ width: '75%' }}></div>
                </div>
                <p className="text-xs text-gray-500 mt-1">Renovación: 15/05/2025</p>
              </div>
            </div>

            <div className="mt-6 border rounded-lg bg-gray-50 p-4">
              <h3 className="font-medium flex items-center mb-3">
                <FiFileText className="mr-2 text-navy-600" /> Estadísticas
              </h3>
              <div className="space-y-3">
                <div className="flex justify-between">
                  <span className="text-gray-600">Casos Activos</span>
                  <span className="font-medium">8</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Documentos</span>
                  <span className="font-medium">37</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Clientes</span>
                  <span className="font-medium">12</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Miembro desde</span>
                  <span className="font-medium">{userData.memberSince}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - User Info Form */}
          <div className="md:w-2/3">
            <div className="bg-white border rounded-lg">
              <div className="flex justify-between items-center px-4 py-3 border-b">
                <h3 className="font-medium flex items-center">
                  <FiInfo className="mr-2 text-navy-600" /> Datos Personales
                </h3>
                {!editing ? (
                  <button
                    onClick={() => setEditing(true)}
                    className="text-navy-600 hover:text-navy-800 flex items-center text-sm"
                  >
                    <FiEdit2 className="mr-1" /> Editar
                  </button>
                ) : null}
              </div>

              <div className="p-4">
                <form onSubmit={handleSubmit}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Nombre completo</label>
                      {editing ? (
                        <input
                          type="text"
                          name="name"
                          value={accountData?.username}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-navy-500"
                          required
                        />
                      ) : (
                        <p className="text-gray-800">{accountData?.username}</p>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                      {editing ? (
                        <input
                          type="email"
                          name="email"
                          value={accountData?.email}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-navy-500"
                          required
                        />
                      ) : (
                        <div className="flex items-center">
                          <FiMail className="text-gray-500 mr-2" />
                          <p className="text-gray-800">{accountData?.email}</p>
                        </div>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Teléfono</label>
                      {editing ? (
                        <input
                          type="text"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-navy-500"
                        />
                      ) : (
                        <div className="flex items-center">
                          <FiPhone className="text-gray-500 mr-2" />
                          <p className="text-gray-800">{userData.phone}</p>
                        </div>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Profesión</label>
                      {editing ? (
                        <input
                          type="text"
                          name="profession"
                          value={formData.profession}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-navy-500"
                        />
                      ) : (
                        <p className="text-gray-800">{userData.profession}</p>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Especialidad</label>
                      {editing ? (
                        <input
                          type="text"
                          name="specialty"
                          value={formData.specialty}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-navy-500"
                        />
                      ) : (
                        <p className="text-gray-800">{userData.specialty}</p>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Dirección</label>
                      {editing ? (
                        <input
                          type="text"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-navy-500"
                        />
                      ) : (
                        <p className="text-gray-800">{userData.address}</p>
                      )}
                    </div>
                  </div>

                  {editing && (
                    <div className="mt-6 flex justify-end space-x-3">
                      <button
                        type="button"
                        onClick={handleCancel}
                        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                      >
                        Cancelar
                      </button>
                      <button
                        type="submit"
                        className="px-4 py-2 bg-navy-600 text-white rounded-md hover:bg-navy-700 flex items-center"
                      >
                        <FiSave className="mr-2" /> Guardar Cambios
                      </button>
                    </div>
                  )}
                </form>
              </div>
            </div>

            <div className="mt-6 bg-white border rounded-lg">
              <div className="px-4 py-3 border-b flex items-center">
                <FiShield className="mr-2 text-navy-600" />
                <h3 className="font-medium">Privacidad y Seguridad</h3>
              </div>

              <div className="p-4">
                <div className="space-y-4">
                  <div>
                    <label className="flex items-center">
                      <input type="checkbox" className="form-checkbox text-navy-600 rounded focus:ring-navy-500 h-4 w-4" defaultChecked />
                      <span className="ml-2 text-gray-700">Activar autenticación de dos factores</span>
                    </label>
                  </div>

                  <div>
                    <label className="flex items-center">
                      <input type="checkbox" className="form-checkbox text-navy-600 rounded focus:ring-navy-500 h-4 w-4" defaultChecked />
                      <span className="ml-2 text-gray-700">Recibir notificaciones de acceso a mi cuenta</span>
                    </label>
                  </div>

                  <div>
                    <label className="flex items-center">
                      <input type="checkbox" className="form-checkbox text-navy-600 rounded focus:ring-navy-500 h-4 w-4" defaultChecked />
                      <span className="ml-2 text-gray-700">Permitir acceso desde dispositivos confiables</span>
                    </label>
                  </div>
                </div>

                <div className="mt-4">
                  <button className="text-navy-600 hover:text-navy-800 text-sm font-medium">
                    Cambiar contraseña
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}